import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-on-map',
  templateUrl: './view-on-map.component.html',
  styleUrls: ['./view-on-map.component.css']
})
export class ViewOnMapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
